import React, { useState, useEffect, useCallback, useContext } from "react";
import { AuthContext } from '../AuthContext';
import { Link } from "react-router-dom";
import s from '../styles/VehicleList.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faPen } from "@fortawesome/free-solid-svg-icons";

const VehicleListArhive = () => {
  const { role } = useContext(AuthContext);
  const [vehicles, setVehicles] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filteredVehicles, setFilteredVehicles] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("Всего");
  const [statusCounts, setStatusCounts] = useState({ total: 0, process: 0, ready: 0 });

  const [filterServiceRequest, setFilterServiceRequest] = useState("Все"); // Фильтр по заявке в сервис
  const [searchQuery, setSearchQuery] = useState(""); // Поле поиска

  const [showModal, setShowModal] = useState(false);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const fetchVehicles = useCallback(async () => {
    try {
      const response = await fetch("/api/arhiv_vehicles");
      if (!response.ok) throw new Error("Ошибка загрузки данных");
      const data = await response.json();
      setVehicles(data);
      countStatuses(data);
      setFilteredVehicles(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, []);

  // 📌 Подсчет статусов
  const countStatuses = (vehicles) => {
    let total = vehicles.length;
    let process = vehicles.filter((v) => v.vehicle_status === "В процессе").length;
    let ready = vehicles.filter((v) => v.vehicle_status === "Готов").length;
    setStatusCounts({ total, process, ready });
  };

  // 📌 Фильтрация списка машин
  useEffect(() => {
    let filtered = vehicles;

    // Фильтр по статусу
    if (selectedStatus !== "Всего") {
      filtered = filtered.filter((v) => v.vehicle_status === selectedStatus);
    }

    // Фильтр по наличию заявки в сервис
    if (filterServiceRequest === "С заявкой") {
      filtered = filtered.filter((v) => v.service_plan && v.service_plan.trim() !== "");
    } else if (filterServiceRequest === "Без заявки") {
      filtered = filtered.filter((v) => !v.service_plan || v.service_plan.trim() === "");
    }

    // Фильтр по поисковому запросу
    if (searchQuery.trim() !== "") {
      filtered = filtered.filter((v) =>
        v.vin.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.brand.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.model.toLowerCase().includes(searchQuery.toLowerCase()) ||
        v.vehicle_type.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (v.color && v.color.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (v.errors && v.errors.toLowerCase().includes(searchQuery.toLowerCase()))
      );
    }

    setFilteredVehicles(filtered);
  }, [vehicles, selectedStatus, filterServiceRequest, searchQuery]);

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  // 📌 Открытие модального окна
  const handleDeleteClick = (vehicle) => {
    setSelectedVehicle(vehicle);
    setShowModal(true);
  };

  // 📌 Закрытие модального окна
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVehicle(null);
  };

  // 📌 Удаление автомобиля
  const handleDeleteVehicle = async () => {
    if (!selectedVehicle) return;

    try {
      const response = await fetch(`/api/vehicles/delete/${selectedVehicle.id}`, {
        method: "DELETE",
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || "Ошибка при удалении");

      fetchVehicles(); // Обновляем список машин
      handleCloseModal(); // Закрываем модальное окно
    } catch (err) {
      setError(err.message);
    }
  };

  if (loading) return <p>Загрузка...</p>;
  if (error) return <p style={{ color: "red" }}>Ошибка: {error}</p>;

  return (
    <div className={s.arhive_container}>
      <h2>Архив</h2>
    <div className={s.container}>
      {/* Фильтры */}
      <div className={s.filter_all}>
        <input
          type="text"
          placeholder="Поиск (VIN, марка, модель, тип, цвет, ошибки)"
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className={s.searchInput}
        />

        <select onChange={(e) => setFilterServiceRequest(e.target.value)} value={filterServiceRequest} className={s.filterSelect}>
          <option value="Все">Все заявки</option>
          <option value="С заявкой">С заявкой</option>
          <option value="Без заявки">Без заявки</option>
        </select>
      </div>

      {/* Фильтр по статусу */}
      {/* <div className={s.status}>
        <div className={s.statusItem} onClick={() => setSelectedStatus("Всего")} style={{flex: "1", cursor: "pointer", fontWeight: selectedStatus === "Всего" ? "bold" : "normal" }}>
          <p className={s.vehicleInfoP_ALL}>{selectedStatus === "Всего" && <span className={s.greenDot}></span>}Всего: <strong>{statusCounts.total}</strong></p>
        </div>
        <div className={s.statusItem} onClick={() => setSelectedStatus("В процессе")} style={{flex: "1", cursor: "pointer", fontWeight: selectedStatus === "В процессе" ? "bold" : "normal" }}>
        <p className={s.vehicleInfoP_proccess}> {selectedStatus === "В процессе" && <span className={s.greenDot}></span>}В процессе: <strong>{statusCounts.process}</strong></p>
        </div>
        <div className={s.statusItem} onClick={() => setSelectedStatus("Готов")} style={{flex: "1", cursor: "pointer", fontWeight: selectedStatus === "Готов" ? "bold" : "normal" }}>
        <p className={s.vehicleInfoP_gotovo}>{selectedStatus === "Готов" && <span className={s.greenDot}></span>}Готово: <strong>{statusCounts.ready}</strong></p>
        </div>
      </div> */}

      {/* Список автомобилей */}
      <div className={s.listContainer}>
        {filteredVehicles.map((vehicle) => (
          <div key={vehicle.id} className={s.item}>
           <div className={s.div_one}> 
          <Link key={vehicle.id} to={`/vehicles/${vehicle.id}`} className={s.vehicleCard}>
              
                  <div className={s.image_container}>
                  <img
                    src={vehicle.photo_3_4_front_left_url ? `${process.env.PUBLIC_URL}/vehicles/${vehicle.photo_3_4_front_left_url}` : "/vehicles/default.jpg"}
                    alt="Фото авто"
                    className={s.vehicleImage}
                  />
              </div>
              <div className={s.vehicleInfo}>
                <p className={s.vehicleInfoP}><strong>{vehicle.vin}</strong></p>
                <p className={s.vehicleInfoP}>{vehicle.color}</p>
                  <div className={s.div_Info}>
                  <p className={s.vehicleInfoP}>
                      {vehicle.date_acceptance
                        ? (vehicle.date_acceptance === "1970-01-01"
                            ? "Отсутствует"
                            : vehicle.date_acceptance.split("-").reverse().join("-"))
                        : "Отсутствует"}
                    </p>
                    <p className={vehicle.vehicle_status === "Готов" ? s.statusReady : s.statusInProgress}>
                      {vehicle.vehicle_status}
                    </p>

                  </div>
              </div>
                </Link>
                  <div>
                        {/* Кнопка "Удалить" */}
                    {role === "superadmin" || role === "admin" || role === "full" ? (
                      <div className={s.trash_div} >
                        <FontAwesomeIcon icon={faTrash} size="lg" color="red" onClick={() => handleDeleteClick(vehicle)} />
                      </div>
                    ) : null}
                    {role === "superadmin" || role === "admin" || role === "full" || role === "prefull"  || role === "office-manager" || role === "service" ? (
                       <Link key={vehicle.id} to={`/update/${vehicle.id}`} className={s.vehicleCard}>
                       <FontAwesomeIcon icon={faPen} size="lg" color="#636363"/> 
                        </Link>
                    ) : null}
                    
                    
                  </div>
                </div>
            </div>
            

            
        ))}
      </div>
      {/* Модальное окно подтверждения удаления */}
      {showModal && selectedVehicle && (
        <div className={s.modalOverlay}>
          <div className={s.modalContent}>
            <h3>Удалить автомобиль?</h3>
            <p><strong>{selectedVehicle.vin}</strong></p>
            <p>{selectedVehicle.brand} - {selectedVehicle.vehicle_type}</p>
            {error && <p className={s.error}>{error}</p>}
            <div className={s.modalButtons}>
              <button onClick={handleDeleteVehicle} className={s.confirmButton}>Удалить</button>
              <button onClick={handleCloseModal} className={s.cancelButton}>Отмена</button>
            </div>
          </div>
        </div>
        
      )}
    </div>
    </div>
)};
   

export default VehicleListArhive;
